import { render, staticRenderFns } from "./RegisterTerms.vue?vue&type=template&id=c28f084e&scoped=true&"
import script from "./RegisterTerms.vue?vue&type=script&lang=js&"
export * from "./RegisterTerms.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTerms.vue?vue&type=style&index=0&id=c28f084e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28f084e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCheckbox,VForm})
